import { SupportManagement } from '../modal';
import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';

export default function reducer(state: SupportManagement = new SupportManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SUPPORT_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SUPPORT_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SUPPORT_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingError: true,
        data: payload,
      };
    default:
      return state;
  }
}
